import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTransportationDetails } from "../../../actions";
import { placeKey,incotermKey, descriptionKey } from "../../../util/NL_fieldPatterns";
import TradeTermsForm from "./tradeTermsForm";


const TradeTerms=({isDMS,isImportShipment,validateError,fieldPattern,saveForm})=>{

  const dispatch=useDispatch()
  const dataSource=useSelector((state)=>state.Shipment.transportation.tradeTerms)


  const placeError=useSelector((state)=>state.ValidationErrors.header?.[placeKey]?.msg)
  const incotermError=useSelector((state)=>state.ValidationErrors.header?.[incotermKey]?.msg)
  const descriptionError=useSelector((state)=>state.ValidationErrors.header?.[descriptionKey]?.msg)
  
  const onUpdate=(payload)=>dispatch(updateTransportationDetails({key:"tradeTerms",payload}))
  
  const saveData=(params)=>saveForm({transportation:{tradeTerms:params}})
  
  return (
   <TradeTermsForm 
     dataSource={dataSource}
     onUpdate={onUpdate}
     saveData={saveData}
     errorInfo={{placeError,incotermError,descriptionError}}
     isDMS={isDMS}
     isImportShipment={isImportShipment}
     validateError={validateError}
     fieldPattern={fieldPattern}

   />
  );
}

export default React.memo(TradeTerms)
